var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6569 21.6C16.3169 21.6 16.8569 21.06 16.8569 20.4V2.4H7.25689C6.59689 2.4 6.05688 2.94 6.05688 3.6V16.8H3.65688V3.6C3.65688 1.608 5.26488 0 7.25689 0H20.4569C22.4489 0 24.0569 1.608 24.0569 3.6V4.8H21.6569V3.6C21.6569 2.94 21.1169 2.4 20.4569 2.4C19.7969 2.4 19.2569 2.94 19.2569 3.6V20.4C19.2569 22.392 17.6489 24 15.6569 24H3.65688C1.66488 24 0.0568848 22.392 0.0568848 20.4V19.2H13.2569C13.2569 20.52 14.3369 21.6 15.6569 21.6ZM8.45689 4.8H14.4569V7.2H8.45689V4.8ZM8.45689 9.6H14.4569V12H8.45689V9.6ZM8.45689 14.4H14.4569V16.8H8.45689V14.4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScript);
export default __webpack_public_path__ + "static/media/script.06f29ab80447020951e50c7929169ddb.svg";
export { ForwardRef as ReactComponent };